import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CuadroDatos from '../UI/CuadroDatos.js';
import TablaDatos from '../UI/TablaDatos.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './MaximasPresencias.module.css';
import { ApellidoNombrePuesto } from '../funciones/FuncionesPersona.js';

const MaximasPresencias = ({ club }) => {
  const [Presencias, setPresencias] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (club && club.id) {
      fetchData(`clubes/${club.id}/jugadores/presencias/maximas?cantidad=20`, setPresencias);
    } else {
      setPresencias([]);
    }
  }, [club, fetchData]);

  return (
    <CuadroDatos titulo="Máximas presencias" isCargando={isCargando} errores={erroresGetLista}>
      <TablaDatos
        estilo={`${styles.tablaPresencias}`}
        lista={Presencias}
        isCargando={isCargando}
        textoVacia="No se encontraron presencias"
      >
        <thead>
          <tr>
            <th className={`${styles.itemjugador}`}>Jugador</th>
            <th className={`${styles.columnaCentrada}`}>Partidos</th>
          </tr>
        </thead>
        <tbody className={`${styles.listaPresencias}`}>
          {Presencias &&
            Presencias.map((jugador, index) => (
              <tr key={jugador?.id || index}>
                <td className={`${styles.itemJugador}`}>
                  {jugador && jugador.id ? (
                    <Link
                      className={`${styles.linkJugador}`}
                      to={`/jugador/${jugador.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {ApellidoNombrePuesto(jugador)}
                    </Link>
                  ) : (
                    <span>{jugador ? ApellidoNombrePuesto(jugador) : ''}</span>
                  )}
                </td>
                <td className={`${styles.columnaCentrada}`}>{jugador?.partidosJugados}</td>
              </tr>
            ))}
        </tbody>
      </TablaDatos>
    </CuadroDatos>
  );
};

export default MaximasPresencias;
